import { useAuth } from "../../lib/auth";
import { Settings as Cog, Sheet, HardDrive } from "lucide-react";

export default function AdminSettings() {
  const { user } = useAuth();
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-12">
      <div className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-400">Administrator</div>
      <h1 className="mt-2 text-4xl font-bold tracking-tight">Settings</h1>

      <div className="mt-10 space-y-6">
        <div className="p-6 rounded-2xl border border-zinc-800 bg-zinc-950/60">
          <div className="flex items-center gap-3 mb-4"><Cog className="w-5 h-5 text-cyan-400" /><h3 className="text-lg font-semibold">Admin Account</h3></div>
          <div className="grid sm:grid-cols-2 gap-4 text-sm">
            <div className="p-4 rounded-xl bg-zinc-900 border border-zinc-800">
              <div className="text-xs uppercase text-zinc-500 tracking-wider">Email</div>
              <div className="mt-1">{user?.email}</div>
            </div>
            <div className="p-4 rounded-xl bg-zinc-900 border border-zinc-800">
              <div className="text-xs uppercase text-zinc-500 tracking-wider">Role</div>
              <div className="mt-1 capitalize">{user?.role}</div>
            </div>
          </div>
        </div>

        <div className="p-6 rounded-2xl border border-zinc-800 bg-zinc-950/60">
          <div className="flex items-center gap-3 mb-4"><Sheet className="w-5 h-5 text-emerald-400" /><h3 className="text-lg font-semibold">Google Sheets Sync</h3></div>
          <p className="text-sm text-zinc-400">Configured via <code className="text-cyan-400">GOOGLE_SHEET_ID</code> and <code className="text-cyan-400">GOOGLE_SERVICE_ACCOUNT_JSON</code> in backend .env. When set, every submission is appended as a new row automatically.</p>
        </div>

        <div className="p-6 rounded-2xl border border-zinc-800 bg-zinc-950/60">
          <div className="flex items-center gap-3 mb-4"><HardDrive className="w-5 h-5 text-violet-400" /><h3 className="text-lg font-semibold">Google Drive Storage</h3></div>
          <p className="text-sm text-zinc-400">Set <code className="text-cyan-400">GOOGLE_DRIVE_FOLDER_ID</code> in backend .env to mirror uploaded artwork and audio to Google Drive. Local uploads work regardless.</p>
        </div>
      </div>
    </div>
  );
}
